import React from 'react';
import { breakpoints, colors, spacing } from '../../utils/styleguide';
import Typography from '../component-library/text/Typography';
import { PageSectionComponent } from './pageSections';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Document } from '@contentful/rich-text-types';
import StoreInfo from '../component-library/StoreInfo';
import PrimaryButton from '../component-library/buttons/PrimaryButton';
import getLinkHref from './util/getLinkHref';
import ButtonPromptWrapper from '../component-library/ButtonPromptWrapper';

const MainWrapper = styled.div`
  padding: ${spacing[3]}px ${spacing[4]}px;

  ${breakpoints.tablet} {
    padding: ${spacing[6]}px ${spacing[11]}px;
  }
`;

const CTA = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 24px 48px rgba(0, 26, 82, 0.06), 0px 14.13px 25px rgba(0, 26, 82, 0.0434),
    0px 7.26px 11.75px rgba(0, 26, 82, 0.0337), 0px 2.92px 5.15px rgba(0, 26, 82, 0.0263),
    0px 0.65px 2.23px rgba(0, 26, 82, 0.0166);
  border-radius: 8px;
`;

const CTAContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 568px;
  padding: ${spacing[8]}px ${spacing[4]}px;
`;

const ButtonContainer = styled.div`
  margin-top: ${spacing[6]}px;
`;

const getFirstParagraphFromRichText = (richText: Document): string | null => {
  if (richText.content.length && richText.content[0].content.length) {
    if (richText.content[0].content[0].nodeType === 'text') {
      return richText.content[0].content[0].value;
    }
  }
  return null;
};

const CTAPush: PageSectionComponent<null> = ({
  page,
  section: { fields: { buildingBlock: content, variant } = {} },
}) => {
  const storesInfo = content?.fields?.storesInfo;
  const campaign = page.fields?.category?.fields.name;

  const textColor = variant === 'dark' ? colors.white : colors.black;
  const backgroundColor = variant === 'dark' ? colors.black : colors.white;

  const button = content?.fields.button;
  return (
    <MainWrapper>
      <CTA css={{ backgroundColor: backgroundColor }}>
        <CTAContent>
          {content && (
            <>
              {content.fields.title && (
                <Typography
                  variant="titleH3"
                  color={textColor}
                  css={css`
                    text-align: center;
                  `}
                >
                  {getFirstParagraphFromRichText(content.fields.title)}
                </Typography>
              )}
              {content.fields.description && (
                <Typography
                  variant="body"
                  color={textColor}
                  css={css`
                    text-align: center;
                    margin-top: ${spacing[3]}px;
                    ${breakpoints.desktop} {
                      margin-top: ${spacing[4]}px;
                    }
                  `}
                >
                  {getFirstParagraphFromRichText(content.fields.description)}
                </Typography>
              )}
              {button?.sys.contentType.sys.id === 'contextualButton' && (
                <ButtonContainer>
                  <ButtonPromptWrapper prompt={button.fields.prompt} variant={variant}>
                    <PrimaryButton
                      color={variant === 'light' ? 'onLight' : 'onDark'}
                      label={button.fields.label}
                      tag="a"
                      href={getLinkHref(button?.fields.link)}
                      size="small"
                    />
                  </ButtonPromptWrapper>
                </ButtonContainer>
              )}
              <StoreInfo
                creative="cta push"
                campaign={campaign}
                storesInfo={storesInfo}
                variant={variant}
                css={css`
                  margin-top: ${spacing[4]}px;
                `}
              />
            </>
          )}
        </CTAContent>
      </CTA>
    </MainWrapper>
  );
};

export default CTAPush;
